// extracted by mini-css-extract-plugin
export var circle = "_f1-1";
export var exitConfirmationModal = "_f1-5";
export var iframe = "_f1-0";
export var offline = "_f1-3";
export var online = "_f1-2";
export var workstationSelectError = "_f1-4";